import {Injectable} from '@angular/core';
import {I18NextPipe} from 'angular-i18next';
import {DropDownListComponent} from 'app/shared/components/drop-down-list/drop-down-list.component';
import {SearchInputComponent} from 'app/shared/components/search-input/search-input.component';

@Injectable()
export class PlaceholdersService {
    constructor(private i18Next: I18NextPipe) {}

    init() {
        SearchInputComponent.PLACEHOLDER = this.i18Next.transform('forms.searchPlaceholder');
        DropDownListComponent.EMPTY_PLACEHOLDER = this.i18Next.transform('forms.select');
        DropDownListComponent.NO_RESULTS_PLACEHOLDER = this.i18Next.transform('forms.noResults');
    }
}
